

export const MaximumOptionLength = 60;
